module.exports = __webpack_public_path__ + "img/iot-scene-remote.cc2686ac.png";